import React, { useEffect, useState, createContext, useContext } from 'react'
import axiosInstance from "./axiosInterceptor"
import { getUserId, setPosName } from './authorize'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [positions, setPositions] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [teacherId] = useState(getUserId())

  useEffect(() => {
    if (!teacherId) {
      setIsLoading(false)
      return
    }
    axiosInstance.get(`/api/getUserPositions/${teacherId}`)
      .then(response => {
        const data = response.data.positions || []
        setPositions(data)
        const posName = data.map(p => p.pos_name).filter(Boolean).join(', ')
        setPosName(posName)
      })
      .catch(error => {
        console.error('Error fetching positions:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [teacherId])

  const posIds = positions.map(p => p.pos_id)

  return (
    <AuthContext.Provider value={{ posIds, isLoading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)